<script setup lang="ts">
import MapControlPanel from '@/components/_common/navbar/MapControlPanel.vue';
import ThreeColumnLayout from "@/components/_common/ThreeColumnLayout.vue";
import GeofenceMap from '@/components/geofence/map/GeofenceMap.vue';
import GeofenceEditView from '@/views/GeofenceEditView.vue';
import GeofenceEditNavBar from '@/components/geofence/edit/GeofenceEditNavBar.vue';

import { useSynchronizedSidebars } from "@/composables/useSynchronizedSidebars";
useSynchronizedSidebars();

import {useResetChatOnSidebarClose} from "@/composables/useResetChatOnSidebarClose";
useResetChatOnSidebarClose();

import {useResetChatOnAccountOrUserChange} from "@/composables/useResetChatOnAccountOrUserChange";
useResetChatOnAccountOrUserChange();


import {setTitle} from "@/utils/title";
setTitle('Edit Geofence');
</script>


<template>
  <ThreeColumnLayout>
    <template #leftTop>
      <GeofenceEditNavBar />
    </template>
    <template #left>
      <GeofenceEditView />
    </template>
    <template #rightTop>
      <MapControlPanel />
    </template>
    <template #right>
      <GeofenceMap view="edit" />
    </template>
  </ThreeColumnLayout>
</template>
